var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6425 0.226318C12.905 0.226318 11.3499 1.08056 10.3804 2.39103C9.41082 1.08056 7.85572 0.226318 6.11823 0.226318C3.17122 0.226318 0.780975 2.65313 0.780975 5.65266C0.780975 6.80782 0.963363 7.87562 1.28014 8.86576C2.79684 13.7194 7.47174 16.6218 9.78519 17.4178C10.1116 17.5343 10.6491 17.5343 10.9755 17.4178C13.289 16.6218 17.9639 13.7194 19.4806 8.86576C19.7973 7.87562 19.9797 6.80782 19.9797 5.65266C19.9797 2.65313 17.5895 0.226318 14.6425 0.226318Z",
    fill: "#FF6A55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedHeart);
export default __webpack_public_path__ + "static/media/red-heart.86eef3670747304e86c895e24bcdd96b.svg";
export { ForwardRef as ReactComponent };